import React, { useEffect, useRef, useState } from "react";
import AdminAppBar from "../../adminComponents/AdminAppBar";
import TagInput from "./TagInput";
import LeadSource from "./LeadSource";
import Location from "./Location";
import { toast, ToastContainer } from "react-toastify";
import Modal from "react-modal";
import { getIcons } from "../../Constant/Constant";
import * as xlsx from "xlsx";
import { showErrorToast, showSuccessToast } from "../../Constant/Notification";
import InterestedTagService from "../../Services/InterestedTagService";
import { dataLimitation } from "../../../Enum";
import CustomHeading from "../../common/CustomHeading";


const InterestAndSources = () => {
    const [selectedFile, setSelectedFile] = useState(null);
  const [inputJson, setInputJson] = useState(null);
  const [interestedTags, setInterestedTags] = useState(0);
  const [leadSource, setLeadSource] = useState(0);
  const [location, setLocation] = useState(0);
  
  
  
  const [tagLimits, setTagLimits] = useState({
    interestTag: dataLimitation?.interestTag || 250,
    leadSource: dataLimitation?.leadSource || 250,
    location: dataLimitation?.locationTag || 250
  });


  const [limitsExceeded, setLimitsExceeded] = useState({
    interestTag: false,
    leadSource: false,
    location: false
  });

  const [interestAndSourceIsOpen, setInterestAndSourceIsOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalHeading, setModalHeading] = useState("");
  const [isModalTemplateOpen, setIsModalTemplateOpen] = useState(false);
  


  
  const dropdownMenuRef = useRef(null); 
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "35%",
      padding: "20px",
      position: "relative",
    },
    overlay: {
      zIndex: 1000,
      backgroundColor: "rgba(0, 0, 0, 0.75)",
    },
  };
  Modal.setAppElement("#root");

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedFile(null);
  };

  useEffect(() => {
    setLimitsExceeded({
      interestTag: interestedTags >= tagLimits.interestTag,
      leadSource: leadSource >= tagLimits.leadSource,
      location: location >= tagLimits.location
    });
  }, [interestedTags, leadSource, location, tagLimits]);

  const showToast = (message, type) => {
    if (type === "success") {
      toast.success(message, {
        position: "top-center",
        theme: "light",
      });
    } else if (type === "error") {
      toast.error(message, {
        position: "top-center",
        theme: "light",
      });
    }
  };
  
  const icon = getIcons();
  
  const handleDropDownMenu = () => {
    setInterestAndSourceIsOpen(!interestAndSourceIsOpen);
  };


  const handleClickOutside = (event) => {
    if (dropdownMenuRef.current && !dropdownMenuRef.current.contains(event.target)) {
      setInterestAndSourceIsOpen(false); 
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside); 
    };
  }, []);

  const handleItemClick = (heading, event) => {
    event.stopPropagation(); 
    
    if (heading === "Interest Tags" && limitsExceeded.interestTag) {
      showErrorToast(`You've reached the maximum limit of ${tagLimits.interestTag} interest tags`);
      return;
    }
    
    if (heading === "Lead Sources" && limitsExceeded.leadSource) {
      showErrorToast(`You've reached the maximum limit of ${tagLimits.leadSource} lead sources`);
      return;
    }
    
    if (heading === "Location" && limitsExceeded.location) {
      showErrorToast(`You've reached the maximum limit of ${tagLimits.location} locations`);
      return;
    }
    
    setModalHeading(heading);
    setIsModalOpen(true);
    setInterestAndSourceIsOpen(false);
  };


  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const validFileTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'text/csv'];

    if (file && !validFileTypes.includes(file.type)) {
      showErrorToast('Invalid file type. Only .xlsx and .csv files are allowed.');
      setSelectedFile(null);
      return;
    }

    setSelectedFile(file);

    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = xlsx.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const json = xlsx.utils.sheet_to_json(worksheet);
        const names = new Set();


        for (let i = 0; i < json.length; i++) {
          if (!json[i]["Name"]) {
            showErrorToast("Missing name in one or more entries");
            setSelectedFile(null);
            return;
          }
          
          const name = String(json[i]["Name"]).toLowerCase();

          if (name.length > 50) {
            showErrorToast("Name cannot exceed 50 characters.");
            setSelectedFile(null);
            return;
          }
          if (names.has(name)) {
            showErrorToast("Duplicate names found in the file. Please correct and try again.");
            setSelectedFile(null);
            return;
          } else {
            names.add(name);
          }
        }
        
     
        const currentCount = modalHeading === "Interest Tags" ? interestedTags :
                            modalHeading === "Lead Sources" ? leadSource :
                            modalHeading === "Location" ? location : 0;
                            
        const limit = modalHeading === "Interest Tags" ? tagLimits.interestTag :
                     modalHeading === "Lead Sources" ? tagLimits.leadSource :
                     modalHeading === "Location" ? tagLimits.location : 0;

                     console.log( " currentCount: ", currentCount);
                     console.log( " limit: ", limit);
                     console.log( " json.length: ", json.length);

                     
        if (currentCount + json.length > limit) {
          showErrorToast(`Uploading these items would exceed the maximum limit of ${limit}`);
          setSelectedFile(null);
          return;
        }
        
        let inputJson = [];
        json.forEach((item) => {
          inputJson.push({
            name: String(item["Name"]).toLowerCase(),
          });
        });
        
        setInputJson(inputJson);
      };
      reader.readAsArrayBuffer(e.target.files[0]);
    }
  };
  
  const fileObj = {
    items: inputJson
  };
  
  const handleUpload = async () => {
    try {
      if (!selectedFile) {
        showErrorToast("Please select a file before uploading.");
        return;
      }
      
      const response = await InterestedTagService.bulkUploadInterestAndsources(fileObj, modalHeading);
      console.log(response.data);
      setIsModalOpen(false);
      setSelectedFile(null);
      window.location.reload();
      showSuccessToast("Bulk Upload completed successfully!");
    } catch (error) {
      console.log(error.message);
      showErrorToast("Error uploading file. Please try again.");
    }
  };

  const handleDownloadTemplate = () => {
    const link = document.createElement("a");
    link.href = "/Sample Interest and Sources.xlsx";
    link.setAttribute("download", "Sample-template Interest and Sources.xlsx");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  

  const handleInterestTags = (e) => {
    console.log("Tag", e);
    setInterestedTags(e);
    
    
    if (e >= tagLimits.interestTag - 5 && e < tagLimits.interestTag) {
      showToast(`You're approaching the interest tag limit (${e}/${tagLimits.interestTag})`, "warning");
    }
  };
  
  const handleLeadSource = (e) => {
    console.log("Lead Source", e);
    setLeadSource(e);

    if (e >= tagLimits.leadSource - 3 && e < tagLimits.leadSource) {
      showToast(`You're approaching the lead source limit (${e}/${tagLimits.leadSource})`, "warning");
    }
  };

  const handleLocation = (e) => {
    console.log("Location", e);
    setLocation(e);
    
    if (e >= tagLimits.location - 3 && e < tagLimits.location) {
      showToast(`You're approaching the location limit (${e}/${tagLimits.location})`, "warning");
    }
  };

  return (
    <>
      <div className="bg-appGrayBackground h-screen">
        <AdminAppBar />
        <ToastContainer />
        <div className="bg-appGrayBackground mt-20 pt-4 px-6 pb-12">
          <div className="flex justify-between  mt-4 px-2">
          <CustomHeading title={`Interest & Sources`} isIcon={true}/> 

            <div className="flex flex-col items-center">
              <button
                onClick={handleDropDownMenu}
                className="bg-customGreen rounded-md p-1 px-5 w-fit text-lg text-white h-10 text-center"
              >
                Bulk Import
              </button>
              {interestAndSourceIsOpen && (
                <div
                  ref={dropdownMenuRef}
                  className="absolute mt-12 bg-white z-50 rounded-md shadow-md w-40 py-2"
                >
                  <ul className="list-none">
                    <li
                      className={`border-b border-gray-300 py-2 text-center hover:text-[#399E79] ${limitsExceeded.interestTag ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                      onClick={(event) => handleItemClick("Interest Tags", event)}
                    >
                      Interest Tags
                    </li>
                    <li
                      className={`border-b border-gray-300 py-2 text-center hover:text-[#399E79] ${limitsExceeded.leadSource ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                      onClick={(event) => handleItemClick("Lead Sources", event)}
                    >
                      Lead Source
                    </li>
                    <li
                      className={`border-b border-gray-300 py-2 text-center hover:text-[#399E79] ${limitsExceeded.location ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                      onClick={(event) => handleItemClick("Location", event)}
                    >
                      Location
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>

          <div className="mt-5 mx-8 flex-flex-col bg-white rounded-md shadow-md p-6">
            <div className="flex justify-between items-center">
              <h1 className="text-2xl font-bold">Interest Tags</h1>
              <span className={`text-sm ${interestedTags >= tagLimits.interestTag * 0.8 ? 'text-red-500' : 'text-gray-500'}`}>
                {interestedTags}/{tagLimits.interestTag} Interest Tags
              </span>
            </div>
            <TagInput 
              showToast={showToast} 
              handleInterestTags={handleInterestTags} 
              maxTags={tagLimits.interestTag}
              disableInput={interestedTags >= tagLimits.interestTag}
            />
            
            <div className="mt-5">
              <div className="flex justify-between items-center">
                <h1 className="text-2xl font-bold">Lead Source</h1>
                <span className={`text-sm ${leadSource >= tagLimits.leadSource * 0.8 ? 'text-red-500' : 'text-gray-500'}`}>
                  {leadSource}/{tagLimits.leadSource} Lead Source used
                </span>
              </div>
              <LeadSource 
                showToast={showToast} 
                handleLeadSource={handleLeadSource} 
                maxSources={tagLimits.leadSource}
                disableInput={leadSource >= tagLimits.leadSource}
              />
              
              <div className="flex justify-between items-center mt-5">
                <h1 className="text-2xl font-bold">Location</h1>
                <span className={`text-sm ${location >= tagLimits.location * 0.8 ? 'text-red-500' : 'text-gray-500'}`}>
                  {location}/{tagLimits.location} locations used
                </span>
              </div>
              <Location 
                showToast={showToast} 
                handleLocation={handleLocation} 
                maxLocations={tagLimits.location}
                disableInput={location >= tagLimits.location}
              />
            </div>
          </div>
        </div>
      </div>

      <Modal
        isOpen={isModalOpen}
        onRequestClose={handleCloseModal}
        contentLabel="Delete Template"
        style={customStyles}
      >
        <div className="flex justify-between">
          <h2 className="text-2xl text-left font-bold mb-6">Bulk upload for {modalHeading}</h2>
          <button
            onClick={handleCloseModal}
            className="absolute top-2 right-2 text-2xl text-gray-700"
          >
            &times;
          </button>
        </div>

        <div className="mb-8 justify-between w-full gap-5">
          <div className="flex justify-between">
            <label
              className="w-1/4 text-black text-2xl xl:text-xl font-medium"
              htmlFor="file-upload"
            >
              Attach File
            </label>
            <div className="flex gap-5 ">
              <div
                className="flex flex-col items-center cursor-pointer"
                onClick={handleDownloadTemplate}
              >
                <img src={icon.downloadIcon} alt="" className="w-5" />
                <div>Template</div>
              </div>
            </div>
          </div>

          <label className="w-full ml-24 ">
            <div className="relative border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline cursor-pointer">
              <span className="absolute inset-y-0 right-3 flex items-center pl-3">
                <svg
                  className=" md:w-6"
                  width="30"
                  height="30"
                  viewBox="0 0 135 135"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 0H134.449V134.449H0V0Z"
                    fill="white"
                    fill-opacity="0.01"
                  />
                  <path
                    d="M67.2231 123.245H22.4067V11.2036H112.04V67.2242"
                    stroke="#399E79"
                    stroke-width="7.31632"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M99.4365 123.245V86.8313"
                    stroke="#399E79"
                    stroke-width="7.31632"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M86.8325 96.6349L91.0341 92.4334L99.4371 84.0303L107.84 92.4334L112.042 96.6349"
                    stroke="#399E79"
                    stroke-width="7.31632"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M44.8152 44.8159H89.6316"
                    stroke="#399E79"
                    stroke-width="7.31632"
                    stroke-linecap="round"
                  />
                  <path
                    d="M44.8152 67.2241H67.2234"
                    stroke="#399E79"
                    stroke-width="7.31632"
                    stroke-linecap="round"
                  />
                </svg>
              </span>
              <span className="pl-0 pr-3 py-1">
                {selectedFile
                  ? selectedFile.name
                  : "Click here to select a file from your computer"}
              </span>
              <input
                id="file-upload"
                className="absolute inset-0 w-full opacity-0 cursor-pointer"
                type="file"
                onChange={handleFileChange}
              />
            </div>
          </label>
        </div>
        
        <div className="flex justify-between items-center">
          <div className="text-sm text-gray-500">
            {modalHeading === "Interest Tags" && `${interestedTags}/${tagLimits.interestTag} tags used`}
            {modalHeading === "Lead Sources" && `${leadSource}/${tagLimits.leadSource} sources used`}
            {modalHeading === "Location" && `${location}/${tagLimits.location} locations used`}
          </div>
          <button 
            onClick={handleUpload} 
            className="bg-customGreen text-white w-32 rounded-md font-normal py-2"
          >
            Upload
          </button>
        </div>
      </Modal>

      {isModalTemplateOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-lg p-4 md:w-1/2 w-full relative">
            <button
              onClick={() => setIsModalTemplateOpen(false)}
              className="absolute top-2 right-4 text-black font-bold text-xl"
            >
              &times;
            </button>
            <h2 className="text-2xl font-semibold mb-4">
              Excel Template Reference
            </h2>
            <img
              src={icon.excelImage}
              alt="Excel Template Reference"
              className="w-full h-auto"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default InterestAndSources;